<template>
    <div v-if="pageData" class="static-offer-page static-page">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 page-content">
                    <div v-for="block in filteredContentBlocks" :key="block.heading" class="content-block">
                        <h3 v-text="block.heading"></h3>
                        <div v-html="block.content"></div>
                    </div>

                    <div class="d-flex justify-content-center mb-4">
                        <a :href="ctaUrl" class="button continue-button">
                            {{ ctaText }}
                        </a>
                    </div>

                    <div v-html="pageData?.content?.legal_text" class="d-flex justify-content-center legal-text"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import map from 'lodash/map'
import pickBy from 'lodash/pickBy'

export default {
    setup() {
        const store = useStore()
        const router = useRouter()

        return {
            store,
            router,
        }
    },
    data() {
        return {
            ctaUrl: null,
            ctaText: null,
        }
    },
    computed: {
        pageData: function () {
            if (this.store.state.global.page) {
                this.emitter.emit('pageData:loaded')

                return this.store.state.global.page
            }

            return null
        },
        ctaText: function () {
            if (this.pageData.content?.cta_button_text) {
                return this.pageData.content.cta_button_text
            }

            return this.$t('debtSolution.offerPage.continueButton')
        },
        ctaUrl: function () {
            if (this.pageData.content?.override_url) {
                return this.pageData.content.override_url
            } else if (this.$route.query.url) {
                return decodeURIComponent(this?.$route?.query?.url)
            }

            window.location.href = '/'
        },
        filteredContentBlocks() {
            return map(
                pickBy(this.pageData.content, (_, key) => key.startsWith('heading_')),
                (heading, key) => {
                    const index = key.split('_')[1]
                    const content = this.pageData.content[`content_${index}`]
                    return { heading, content }
                },
            )
        },
    },
}
</script>
